const ROLE_OPTIONS = [
  { value: 'Agile Coach', label: 'Agile Coach' },
  { value: 'CEO', label: 'CEO' },
  { value: 'CFO', label: 'CFO' },
  { value: 'CIO', label: 'CIO' },
  { value: 'COO', label: 'COO' },
  { value: 'CTO', label: 'CTO' },
  { value: 'Data Analyst', label: 'Data Analyst' },
  { value: 'Designer', label: 'Designer' },
  { value: 'Developer Advocate', label: 'Developer Advocate' },
  { value: 'DevOps Engineer', label: 'DevOps Engineer' },
  { value: 'Director of Engineering', label: 'Director of Engineering' },
  { value: 'Director of Product', label: 'Director of Product' },
  { value: 'Engineering Manager', label: 'Engineering Manager' },
  { value: 'Executive', label: 'Executive' },
  { value: 'Product Manager', label: 'Product Manager' },
  { value: 'Product Owner', label: 'Product Owner' },
  { value: 'Program Manager', label: 'Program Manager' },
  { value: 'Project Manager', label: 'Project Manager' },
  { value: 'QA Engineer', label: 'QA Engineer' },
  { value: 'Scrum Master', label: 'Scrum Master' },
  { value: 'Software Architect', label: 'Software Architect' },
  { value: 'Software Developer', label: 'Software Developer' },
  { value: 'Team Lead', label: 'Team Lead' },
  { value: 'Technical Lead', label: 'Technical Lead' },
  { value: 'VP of Engineering', label: 'VP of Engineering' },
  { value: 'VP of Product', label: 'VP of Product' },
  { value: 'Other', label: 'Other' },
];

const INPUT_STYLES = {
  input: {
    background: 'var(--sky-lightest)',
    color: 'var(--ink-darkest)',
    borderColor: 'var(--sky-light)',
    borderRadius: 12,
    minHeight: 48,
    fontSize: 16,
    paddingInline: 14,
    '&::placeholder': {
      color: 'var(--ink-lighter)',
      fontSize: 15,
    },
    '&:focus': {
      borderColor: 'var(--flora-focus-border)',
      background: 'var(--base-white)',
    },
  },
};

const SELECT_STYLES = {
  ...INPUT_STYLES,
  section: {
    color: 'var(--ink-lighter)',
    background: 'transparent',
  },
  dropdown: {
    background: 'var(--flora-popover-bg)',
    borderColor: 'var(--flora-popover-border)',
    borderRadius: 12,
    fontSize: 15,
  },
  option: {
    color: 'var(--ink-darkest)',
    borderRadius: 6,
    fontSize: 15,
    paddingBlock: 8,
    '&[data-combobox-selected]': {
      background: 'var(--flora-hover-strong)',
      color: 'var(--ink-darkest)',
    },
    '&:hover': {
      background: 'var(--flora-popover-hover)',
    },
  },
};

export { INPUT_STYLES, ROLE_OPTIONS, SELECT_STYLES };
